(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jrma-club-selector"] && !Shopify.designMode) return;
  try {
    class JrmaClubSelector extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.studentName = this.querySelector('input[name="attributes[Student name]"]');
      this.checkoutButton = document.querySelector('#checkout');
      this.dynamicCheckout = document.querySelector('.cart__dynamic-checkout-buttons');
      this.updateCheckoutState();
      this.select.addEventListener('change', () => this.handleChange());
      this.studentName.addEventListener('input', () => this.updateCheckoutState());
      this.studentName.addEventListener('change', () => this.handleChange());
    }

    updateCheckoutState() {
      const hasClub = this.select.value !== '';
      const hasStudentName = this.studentName.value.trim() !== '';
      const isComplete = hasClub && hasStudentName;
      if (this.checkoutButton) this.checkoutButton.disabled = !isComplete;
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = !isComplete;
    }

    async handleChange() {
      this.updateCheckoutState();
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            Club: this.select.value,
            'Student name': this.studentName.value.trim()
          }
        })
      });
    }
  }

  customElements.define('jrma-club-selector', JrmaClubSelector);
  } catch(e) { console.error(e); }
})();

})();
